// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nselect:disabled,\r\n.form-control:disabled {\r\n  color: #2c2c2c !important;\r\n  opacity: 1 !important;\n}\n[dir] select:disabled, [dir] .form-control:disabled {\r\n  background-color: white !important;\r\n  cursor: not-allowed;\n}\n.table-responsive{\r\n  min-height: 380px;\n}\r\n", ""]);
// Exports
module.exports = exports;
